import React from "react";

import {
  applyMiddleware, combineReducers, compose, createStore,
} from "redux";
import { Provider } from "react-redux";

import thunkMiddleware from "redux-thunk";
import PageBlock from "components/PageBlock";
import PageHero from "components/PageHero";
import TextHeading from "components/TextHeading";
import discoverFiltersReducer from "./components/DiscoverFilters/redux";
import resultsReducer from "./components/Results/redux";
import advancedFiltersReducer from "./components/AdvancedFilters/redux";

import AdvancedFilters from "./components/AdvancedFilters";
import DiscoverFilters from "./components/DiscoverFilters";
import Results from "./components/Results";

import "./style.scss";

const store = createStore(
  combineReducers({
    browseHero: discoverFiltersReducer,
    results: resultsReducer,
    advancedFilters: advancedFiltersReducer,
  }),
  compose(
    applyMiddleware(thunkMiddleware),
    // redux chrome devtools:
    // https://github.com/zalmoxisus/redux-devtools-extension
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f,
  ),
);
const Browse = () => (
  <Provider store={store}>
    <section data-test="discover">
      <PageHero
        heading={
          <TextHeading look="inverse" level={1} size={1}>Discover</TextHeading>
        }
        subheading={(
          <TextHeading look="inverse" light level={2} size={5}>
            Find causes you truly care about
          </TextHeading>
        )}
        cta={
          <DiscoverFilters />
        }
        look="gradient"
        minHeight="normal"
        textAlign="center"
      />
      <AdvancedFilters />
      <PageBlock isNoPaddingTop look="light" size="short">
        <Results />
      </PageBlock>
    </section>
  </Provider>
);

export default Browse;
